import framework from '@/utils/framework'
import util from '@/utils/util'
import Vue from 'vue'
import * as math from 'mathjs'

Vue.prototype.$util = framework
Vue.prototype.$utils = util
Vue.prototype.$math = math